"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const ModuleItemFilter_vue_1 = __importDefault(require("./ModuleItemFilter.vue"));
const CardName_1 = require("@/common/cards/CardName");
const GameModule_1 = require("@/common/cards/GameModule");
const ClientCardManifest_1 = require("@/client/cards/ClientCardManifest");
const CardType_1 = require("@/common/cards/CardType");
const utils_1 = require("@/common/utils/utils");
function corpCardNames(module) {
    return (0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byModule)(module))
        .filter((0, ClientCardManifest_1.byType)(CardType_1.CardType.CORPORATION))
        .map(utils_1.toName)
        .filter((name) => name !== CardName_1.CardName.BEGINNER_CORPORATION);
}
const interim = GameModule_1.GAME_MODULES.map((module) => [module, []]);
const ALL_CARDS_BY_MODULE = Object.fromEntries(interim);
(0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byType)(CardType_1.CardType.CORPORATION)).forEach((card) => {
    if (card.name !== CardName_1.CardName.BEGINNER_CORPORATION) {
        ALL_CARDS_BY_MODULE[card.module].push(card.name);
    }
});
GameModule_1.GAME_MODULES.forEach((module) => ALL_CARDS_BY_MODULE[module].sort());
const GROUPS = GameModule_1.GAME_MODULES.map((module) => ({ key: module, label: GameModule_1.MODULE_NAMES[module] }));
exports.default = (0, vue_1.defineComponent)({
    name: 'CorporationsFilter',
    components: { ModuleItemFilter: ModuleItemFilter_vue_1.default },
    emits: ['corporation-list-changed', 'close'],
    props: {
        expansions: { type: Object, required: true },
        selected: { type: Array, required: true },
    },
    data() {
        const initialSelected = this.selected.length > 0 ? [...this.selected] : [
            ...corpCardNames('base'),
            ...this.expansions.corpera ? corpCardNames('corpera') : [],
            ...this.expansions.prelude ? corpCardNames('prelude') : [],
            ...this.expansions.prelude2 ? corpCardNames('prelude2') : [],
            ...this.expansions.venus ? corpCardNames('venus') : [],
            ...this.expansions.colonies ? corpCardNames('colonies') : [],
            ...this.expansions.turmoil ? corpCardNames('turmoil') : [],
            ...this.expansions.promo ? corpCardNames('promo') : [],
            ...this.expansions.community ? corpCardNames('community') : [],
            ...this.expansions.moon ? corpCardNames('moon') : [],
            ...this.expansions.pathfinders ? corpCardNames('pathfinders') : [],
            ...this.expansions.underworld ? corpCardNames('underworld') : [],
        ];
        return { initialSelected };
    },
    computed: {
        GROUPS() {
            return GROUPS;
        },
        ALL_CARDS_BY_MODULE() {
            return ALL_CARDS_BY_MODULE;
        },
    },
    methods: {
        compatibility(name) {
            return (0, ClientCardManifest_1.getCard)(name)?.compatibility ?? [];
        },
    },
});
